<template>
    <b-sidebar
      id="add-new-package-sidebar"
      :visible="isSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="$emit('clicked',false)"
      @change="(val) => $emit('one')"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            報表細項
          </h5>
         
        </div>

        <b-list-group>
            <b-list-group-item v-for="(student, key , index) in data.data" :key="index" v-if="student.grade == data.key">
                {{  student.student_name }}  
            </b-list-group-item>
        </b-list-group>
      </template>
    </b-sidebar>
  </template>
  
  <script>
  import {
    BSidebar, BForm, BBadge,BListGroup,BListGroupItem,BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BModal, VBModal, BFormTextarea
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import flatPickr from 'vue-flatpickr-component'
  import { ref } from '@vue/composition-api'
  import { required, alphaNum, email } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import countries from '@/@fake-db/data/other/countries'
  import router from '@/router'
  
  export default {
    components: {
      ToastificationContent,
      flatPickr,
      BSidebar,
      BBadge,
      BForm,
      BFormGroup,
      BFormInput,
      BListGroup,BListGroupItem,
      BFormTextarea,
      BFormInvalidFeedback,
      BButton,
      vSelect,
      BModal, VBModal,
      // Form Validation
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      Ripple,
      'b-modal': VBModal,
    },
    model: {
      prop: 'isAddNewMemberSidebarActive',
      event: 'update:is-add-new-Member-sidebar-active',
    },
    props: {
      data : {
        type: null
      },
      isSidebarActive: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      total() {
        let total = 0
        this.payment_method.forEach((item, i) => {
          total = total + parseInt(item.amount)
        });
  
        return this.transaction.nonpay_amount - total
      },
      default_expiry_date() {
        try {
        var myCurrentDate=new Date();
        var myFutureDate=new Date(myCurrentDate);
        var expiry_figure = Number(this.packageData.package.expiry_figure)
        switch(this.packageData.package.expiry_unit) {
          case "DAY":
            myFutureDate.setDate(myFutureDate.getDate()+ expiry_figure)
            break;
          case "MONTH":
            myFutureDate.setMonth(myFutureDate.getMonth()+ expiry_figure)
            break;
          case "YEAR":
            myFutureDate.setYear(myFutureDate.getFullYear()+ expiry_figure)
            break;
        }
        } catch {
          var myCurrentDate=new Date();
          var myFutureDate=new Date(myCurrentDate);
        }
        return myFutureDate.getFullYear() + "-" +  (myFutureDate.getMonth()+1)  + "-" + myFutureDate.getDate()
      },
      selected_package_price() {
        try {
        return this.packageData.package.price
        } catch {
          return 0
        }
      },
      selected_package_quantity() {
        try {
        switch (Number(this.packageData.package.lock_quantity)) {
          case 0:
            this.lock_quantity = false
            break;
          case 1:
            this.lock_quantity = true
            break;
        }
         return this.packageData.package.quantity
        } catch {
        return 0
        }
  
      }
    },
    data() {
      return {
        payment_method : [],
        iframe_src : '//www.cloudfit.pro/invoice.php',
        required,
        paymentMethodOptions: [
          { label: 'Cash', value: 'cash' },
          { label: 'Visa', value: 'visa' },
        ],
        lock_quantity : true,
        alphaNum,
        email,
        countries,
        blankPackageData: {
          expire_at: '',
        },
        packageData:{
          center_id:0,
          remarks:null,
          package:{
            price:0.00,
            quantity:0,
            payment_method:'',
            expiry_figure:'1',
            expiry_unit:'DAY'
          }
        }
      }
    },
    created() {
    },
    methods: {
    },
    setup(props, { emit }) {
      const blankPackageData = {
        expire_at:'',
        remakrs:'',
        quantity:'',
        package: {
          expiry_figure:'1',
          expiry_unit:'DAY'
        }
      }
  
      const packageData = ref(JSON.parse(JSON.stringify(blankPackageData)))
      const resetuserData = () => {
        packageData.value = JSON.parse(JSON.stringify(blankPackageData))
      }
  
      const onSubmit = () => {
  
      }
  
      const {
        refFormObserver,
        getValidationState,
      } = formValidation(resetuserData)
  
      return {
        packageData,
        onSubmit,
  
        refFormObserver,
        getValidationState,
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  #add-new-user-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
  </style>
  